<template>
  <div>
    <el-card body-style="padding: 0" v-if="reportDate" v-loading="detailLoading">
      <div slot="header" class="card_header">
        <span>{{ reportDate }}</span>
        <el-input
            class="w-200"
            v-model="search"
            size="mini"
            placeholder="搜尋"/>
      </div>
      <ezoom-table
          :has-no="true"
          :title="title"
          :data="detailData"
          :columns="detailColumns"
          :search="search">
        <el-table-column prop="department" sortable label="部門" width="110"/>
        <el-table-column prop="employeeId" sortable label="員工編號" width="110"/>
        <el-table-column prop="employeeName" sortable label="姓名" width="100"/>
        <el-table-column prop="rapidTestType" sortable label="篩檢試劑類型" width="150"/>
        <el-table-column prop="dateStr" sortable label="篩檢日期" width="150"/>
        <el-table-column prop="outcome" sortable label="篩檢結果" width="110"/>
      </ezoom-table>
    </el-card>
    <el-card v-else>
      請選擇左方任一筆統計資料 , 查看詳細內容
    </el-card>
  </div>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import EzoomTable from "@/components/EzoomTable";
import {reportDate, detailLoading, detailData} from "./useRapidTest";

export default {
  name: "RapidTestDetail",
  components: {
    'ezoom-table': EzoomTable,
  },
  setup() {

    const search = ref('');

    const detailColumns = ref([
      {label: "回報日期", prop: "reportDate"},
      {label: "部門", prop: "department"},
      {label: "員工編號", prop: "employeeId"},
      {label: "姓名", prop: "employeeName"},
      {label: "篩檢類別", prop: "rapidTestType"},
      {label: "篩檢日期", prop: "dateStr"},
      {label: "篩檢結果", prop: "outcome"}
    ])

    const title = computed(() => `${reportDate.value}-篩檢明細回報-`);

    return {search, reportDate, title, detailLoading, detailColumns, detailData}
  }
}
</script>

<style scoped>

.card_header {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bolder;
}

.w-200 {
  width: 200px;
}
</style>
